import Select from "react-select"
import React, { Fragment, useState } from "react"
import axios from "axios"
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Input,
  Form,
  CardTitle,
  Label,
  Modal,
} from "reactstrap"
import { API_URL } from "constants/constants"

export const FiltersCard = props => {
  // Keep all original props to maintain compatibility
  const {
    item,
    setItem,
    options,
    filterLabel,
    fromDate = "",
    toDate = "",
    setFromDate = () => {},
    setToDate = () => {},
    showToDate = true,
    setFiltersData = () => {},
    showType,
    setType,
    optionsType,
    type,
  } = props

  const handleSubmit = e => {
    e.preventDefault()
    setFiltersData({
      item: item,
      fromDate: fromDate,
      toDate: toDate,
    })
  }

  // Keep the FileDownloadModal component as-is
  const FileDownloadModal = ({ show, handleClose, files }) => {
    return (
      <Modal isOpen={show} toggle={handleClose} size="lg">
        <div className="modal-header">
          <h5 className="modal-title">Available Reports</h5>
          <Button type="button" className="close" onClick={handleClose}>
            <span>&times;</span>
          </Button>
        </div>
        <div className="modal-body">
          <ul>
            {files.length > 0 ? (
              files.map((file, index) => (
                <li key={index}>
                  <a href={file.url} download>
                    {file.name}
                  </a>
                </li>
              ))
            ) : (
              <p>No reports available.</p>
            )}
          </ul>
        </div>
        <div className="modal-footer">
          <Button color="secondary" onClick={handleClose}>
            Close
          </Button>
        </div>
      </Modal>
    )
  }

  const [files, setFiles] = useState([])
  const [showModal, setShowModal] = useState(false)

  // Maintain the same fetch files function
  const fetchFiles = () => {
    axios
      .get(`${API_URL}/admin/reports/customer-reports-download`)
      .then(response => {
        setFiles(response.data) // Set the fetched files
        setShowModal(true) // Show the modal only after data is fetched
      })
      .catch(error => {
        console.error("Error fetching report files:", error)
      })
  }

  const handleShow = () => {
    fetchFiles() // Fetch files, then show modal after data fetching completes
  }

  const handleClose = () => {
    setShowModal(false)
  }

  // Adding some safety checks for undefined options
  const safeOptions = options || []
  const safeOptionsType = optionsType || []

  return (
    <Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-4"></CardTitle>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col xs={12}>
                <Row>
                  <Col lg={`${showToDate ? 3 : 6}`}>
                    <div className="row mb-4">
                      <Col sm={9} md={2} lg={2}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-sm-3 col-form-label text-nowrap"
                        >
                          From
                        </Label>
                      </Col>
                      <Col sm={3} md={6} lg={10}>
                        <Input
                          type="date"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          onChange={e => {
                            setFromDate(e.target.value)
                          }}
                          value={fromDate}
                        />
                      </Col>
                    </div>
                  </Col>
                  {showToDate && (
                    <Col lg={3}>
                      <div className="row mb-4">
                        <Col sm={9} md={2} lg={2}>
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-3 col-form-label text-nowrap"
                          >
                            To
                          </Label>
                        </Col>
                        <Col sm={9} md={6} lg={10}>
                          <Input
                            type="date"
                            className="form-control"
                            id="horizontal-email-Input"
                            onChange={e => {
                              setToDate(e.target.value)
                            }}
                            value={toDate}
                          />
                        </Col>
                      </div>
                    </Col>
                  )}
                  {showType && (
                    <Col lg={3}>
                      <div className="row mb-4">
                        <Col sm={9} md={2} lg={2}>
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-3 col-form-label text-nowrap"
                          >
                            {[undefined, null, ""].includes(filterLabel)
                              ? "Type"
                              : filterLabel}
                          </Label>
                        </Col>
                        <Col sm={9} md={6} lg={10}>
                          <Select
                            options={safeOptionsType}
                            maxMenuHeight={150}
                            classNamePrefix="select2-selection"
                            onChange={selectedOption => {
                              if (selectedOption && setType) {
                                setType(selectedOption.value)
                              }
                            }}
                            value={
                              safeOptionsType.find(
                                option => option && option.value === type
                              ) || null
                            }
                          />
                        </Col>
                      </div>
                    </Col>
                  )}
                  {!props.notDisplayFilter ? (
                    <Col lg={4}>
                      <div className="row mb-4">
                        <Col sm={3} md={3} lg={3}>
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-3 col-form-label text-nowrap"
                          >
                            {[undefined, null, ""].includes(filterLabel)
                              ? "Type"
                              : filterLabel}
                          </Label>
                        </Col>
                        <Col sm={9} md={9} lg={9}>
                          <Select
                            options={safeOptions}
                            maxMenuHeight={150}
                            classNamePrefix="select2-selection"
                            onChange={selectedOption => {
                              if (selectedOption && setItem) {
                                setItem(selectedOption.label)
                              }
                            }}
                            value={
                              safeOptions.find(option => option && option.label === item) ||
                              null
                            }
                          />
                        </Col>
                      </div>
                    </Col>
                  ) : (
                    ""
                  )}
                  <Col lg={2}>
                    <div className="row mb-4">
                      <Col sm={9} md={2} lg={2}></Col>
                      <Col sm={9} md={6} lg={10}>
                        <div>
                          <Button
                            type="button"
                            color="primary"
                            className="w-md"
                            onClick={() => {
                              if (typeof props.call === 'function') {
                                props.call()
                              }
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Col>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="row mb-4">
                      <Col sm={9} md={2} lg={2}></Col>
                      <Col sm={9} md={6} lg={10}>
                        <div>
                          <Button
                            type="button"
                            color="primary"
                            className="w-md"
                            onClick={handleShow} // Show the modal and fetch files
                          >
                            Download Sheets
                          </Button>
                        </div>
                      </Col>
                      <FileDownloadModal
                        show={showModal}
                        handleClose={handleClose}
                        files={files}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>
    </Fragment>
  )
}

export default FiltersCard